module.exports = __webpack_public_path__ + "img/zijdebrug.36e73258.jpg";